module.exports = __webpack_public_path__ + "img/userDefault2.d03b238b.svg";